import firebase from "firebase/app";
import "firebase/auth"
// Produccion
   const firebaseConfig = {
   apiKey: "AIzaSyAAhFFofuFMxMzmNMUN7K_V0UeX3Jc69Oo",
   authDomain: "tickets-d5283.firebaseapp.com",
   databaseURL: "https://tickets-d5283.firebaseio.com",
   projectId: "tickets-d5283",
   storageBucket: "tickets-d5283.appspot.com",
   messagingSenderId: "403900264461",
   appId: "1:403900264461:web:b4a275a39fa4af64dd2544"
 };

// Dev
/*   const firebaseConfig = {
  apiKey: "AIzaSyA3wO1pvVW0BjCEBkBEuZdiRE5aLH9hGY0",
  authDomain: "tickets-dev-81926.firebaseapp.com",
  databaseURL: "https://tickets-dev-81926.firebaseio.com",
  projectId: "tickets-dev-81926",
  storageBucket: "tickets-dev-81926.appspot.com",
  messagingSenderId: "814423145582",
  appId: "1:814423145582:web:75ffe8e4036e831eb3ba7f"
}; */

export default !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();